import {USER_LOGOUT} from './types';
import {setAuthToken} from '../../../api/api';


export default function UserLogout() {
    localStorage.removeItem('athen_auth');
    setAuthToken(null);

    return {
        type: USER_LOGOUT,
    }
};


/** WEBPACK FOOTER **
 ** ./src/modules/auth/actions/UserLogout.js
 **/